import type { DashboardView } from '@contracts';
import { useFilters } from '@/lib/filterContext';

const VIEWS: { value: DashboardView; label: string }[] = [
  { value: 'ventas', label: 'Ventas' },
  { value: 'vendedor', label: 'Por Vendedor' },
];

/** Segmented control: Ventas (por orden) | Por Vendedor (por comisión acreditada). */
export function ViewToggle() {
  const { view, setView, scope, setScope } = useFilters();

  const pick = (v: DashboardView) => {
    setView(v);
    // Grupo/Empleado solo aplican en vendedor → al volver a Ventas se limpian.
    if (v === 'ventas' && (scope.groups?.length || scope.employees?.length)) {
      setScope({ ...scope, groups: [], employees: [] });
    }
  };

  return (
    <div className="inline-flex rounded-xl bg-slate-100 p-1">
      {VIEWS.map((v) => (
        <button
          key={v.value}
          onClick={() => pick(v.value)}
          className={`rounded-lg px-3.5 py-1.5 text-sm font-bold transition ${
            view === v.value ? 'bg-red-600 text-white shadow' : 'text-slate-500 hover:text-slate-700'
          }`}
        >
          {v.label}
        </button>
      ))}
    </div>
  );
}
